import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@app';
// i18n must be imported before any component that calls useTranslation()
import '@doccareplus/i18n';
import { initAnalytics } from '@doccareplus/shared/lib/analytics';
import '@doccareplus/ui/styles/tokens.css';

// Fire-and-forget: initialises Firebase Analytics only when enabled + configured.
void initAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
